var exports = {
  "k": "dialogContent__OBqUmA",
};

module.exports = exports;
